module.exports = __webpack_public_path__ + "static/img/q4.fe3c672.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/q4.png
// module id = VxHy
// module chunks = 0